import { useState } from "react";
import { Droplet } from "lucide-react";
import { mediaUrl } from "@/lib/api";

export function HoneyDropMorph({ image, className = "" }) {
  const [runKey, setRunKey] = useState(0);

  return (
    <div
      className={`morph-wrap w-56 h-56 sm:w-72 sm:h-72 cursor-pointer ${className}`}
      onClick={() => setRunKey((k) => k + 1)}
      title="Tap to replay"
      data-testid="honey-drop-morph"
    >
      <div key={`d-${runKey}`} className="morph-drop">
        <Droplet className="w-28 h-28 sm:w-36 sm:h-36 morph-glow" style={{ color: "#F59E0B" }} fill="#F59E0B" />
      </div>
      <div key={`i-${runKey}`} className="morph-ins">
        {image ? (
          <img src={mediaUrl(image)} alt="Insulator" className="w-full h-full object-contain morph-glow" />
        ) : (
          <Droplet className="w-36 h-36" style={{ color: "#F59E0B" }} fill="#F59E0B" />
        )}
      </div>
    </div>
  );
}
